import Component from '@cell/cell-core/component/component';
import './filters.scss';

class Filters extends Component {
  constructor() {
    super();

    this.handleFilterRemoveAllClick = this.handleFilterRemoveAllClick.bind(this);
    this.handleActiveValueRemove = this.handleActiveValueRemove.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.remove-all-filters', this.handleFilterRemoveAllClick);
    this.on('active-filter-value.remove', this.handleActiveValueRemove);
  }

  handleFilterRemoveAllClick() {
    this.emit('remove-all-filters', { url: this.parsedDataset.urlToRemoveAll });
  }

  handleActiveValueRemove({ data }) {
    this.emit('remove-active-value', data);
  }
}

customElements.define('c-filters', Filters);
